import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const admissionApi = createApi({
  reducerPath: "admissionApi",
  tagTypes: ["Admissions"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getAdmissions: builder.query({
      query: () => "api/v2/admissions",
      transformResponse: (response: any) => {
        return response.admissions;
      }
    })
  })
});

export const { useGetAdmissionsQuery } = admissionApi;
